import { render, staticRenderFns } from "./shipInvitation.vue?vue&type=template&id=b123b548&scoped=true&"
import script from "./shipInvitation.vue?vue&type=script&lang=js&"
export * from "./shipInvitation.vue?vue&type=script&lang=js&"
import style0 from "./shipInvitation.vue?vue&type=style&index=0&id=b123b548&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123b548",
  null
  
)

export default component.exports